import DefaultTeamsFeatureList from './features/defaultTeamsFeatureList';
import TeamPremierFeatureList from './features/teamPremierFeatureList';
import EnterpriseFeatureList from './features/enterpriseFeatureList';
import FeatureRules from './rules/featureRules';
import summaryFeaturesTransformer from './summaryFeaturesTransformer';

export default summaryFeaturesTransformer(
  [...DefaultTeamsFeatureList, ...TeamPremierFeatureList, ...EnterpriseFeatureList],
  {
    ...FeatureRules,
    // Add feature rule overrides below
  }
);
